export const LOAD_APPLIED_LEAVES_BY_USER = "LOAD_APPLIED_LEAVES_BY_USER";